export const mediaItems = [
  {
    id: 1,
    title: '《星际穿越》4K重制版',
    tag: '科幻经典',
    quality: '4K HDR',
    year: '2024重制',
    desc: '诺兰科幻史诗，IMAX胶片4K扫描重制，浩瀚宇宙尽收眼底',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20deep%20space%20and%20stars%2C%20warm%20golden%20light%20accents%2C%20abstract%20cosmic%20scene%2C%20minimalist%20composition%2C%20elegant%20dark%20background%20with%20subtle%20nebula%20colors%2C%20artistic%20film%20poster%20aesthetic&width=600&height=800&seq=media-01&orientation=portrait',
  },
  {
    id: 2,
    title: '《奥本海默》IMAX版',
    tag: '传记剧情',
    quality: '4K杜比',
    year: '2024上线',
    desc: '克里斯托弗·诺兰执导，基里安·墨菲主演，原子弹之父的传奇人生',
    poster: 'https://readdy.ai/api/search-image?query=Artistic%20film%20poster%20with%20warm%20orange%20and%20amber%20explosion%20tones%2C%20minimalist%20abstract%20fire%20and%20smoke%20composition%2C%20dramatic%20lighting%2C%20elegant%20dark%20background%2C%20cinematic%20aesthetic&width=600&height=800&seq=media-02&orientation=portrait',
  },
  {
    id: 3,
    title: '《沙丘2》加长版',
    tag: '史诗巨制',
    quality: '4K IMAX',
    year: '2025上新',
    desc: '丹尼斯·维伦纽瓦科幻巨制续作，沙漠星球史诗再度展开',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20with%20warm%20desert%20sand%20tones%2C%20abstract%20dune%20landscape%2C%20golden%20hour%20lighting%2C%20minimalist%20composition%2C%20elegant%20warm%20beige%20and%20gold%20color%20palette%2C%20artistic%20film%20aesthetic&width=600&height=800&seq=media-03&orientation=portrait',
  },
  {
    id: 4,
    title: '《阿凡达：水之道》',
    tag: '视觉奇观',
    quality: '4K 3D',
    year: '2024典藏',
    desc: '詹姆斯·卡梅隆十三年匠心之作，潘多拉海洋世界极致呈现',
    poster: 'https://readdy.ai/api/search-image?query=Artistic%20film%20poster%20with%20deep%20ocean%20blue%20and%20cyan%20tones%2C%20abstract%20underwater%20light%20rays%2C%20minimalist%20composition%2C%20ethereal%20aquatic%20atmosphere%2C%20elegant%20dark%20background%2C%20cinematic%20water%20aesthetic&width=600&height=800&seq=media-04&orientation=portrait',
  },
  {
    id: 5,
    title: '《流浪地球2》',
    tag: '国产科幻',
    quality: '4K原盘',
    year: '2024热播',
    desc: '中国科幻电影里程碑续作，人类命运共同体的宇宙篇章',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20with%20warm%20orange%20sun%20and%20earth%20tones%2C%20abstract%20cosmic%20composition%2C%20dramatic%20warm%20lighting%2C%20minimalist%20space%20theme%2C%20elegant%20dark%20background%2C%20artistic%20sci-fi%20aesthetic&width=600&height=800&seq=media-05&orientation=portrait',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '真4K超清画质',
    desc: '原生4K分辨率片源，支持HDR10+与杜比视界，每一帧都是视觉盛宴。告别模糊与马赛克，体验前所未有的清晰度。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    desc: '全球CDN加速节点覆盖，智能码率自适应技术，无论何时何地都能享受零卡顿的流畅观影体验。',
  },
  {
    id: 3,
    icon: 'ri-movie-2-line',
    title: '海量影视资源',
    desc: '涵盖院线大片、经典老片、热门剧集、纪录片等全品类内容，每日更新，精彩不断档。',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '院线大片专区',
    tag: '热映',
    desc: '同步院线最新上映影片，4K超清画质抢先体验，足不出户享受影院级视听盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20scene%20with%20warm%20red%20velvet%20curtains%2C%20soft%20golden%20stage%20lighting%2C%20elegant%20empty%20cinema%20hall%2C%20minimalist%20composition%2C%20luxurious%20atmosphere%2C%20warm%20amber%20and%20crimson%20tones&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '高分美剧合集',
    tag: '热门',
    desc: 'IMDb、豆瓣高分美剧一网打尽，从经典老剧到最新季更，4K画质全程高能。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20scene%20with%20large%20TV%20screen%2C%20warm%20ambient%20lighting%2C%20modern%20minimalist%20interior%2C%20comfortable%20sofa%2C%20evening%20atmosphere%2C%20soft%20golden%20and%20warm%20gray%20tones&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国产剧热播榜',
    tag: '追剧',
    desc: '热门国产电视剧同步更新，古装、都市、悬疑全题材覆盖，4K画质让细节分毫毕现。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20ancient%20style%20interior%20with%20warm%20lantern%20light%2C%20soft%20silk%20textures%2C%20traditional%20wooden%20architecture%2C%20minimalist%20composition%2C%20warm%20amber%20and%20red%20tones%2C%20cinematic%20atmosphere&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '纪录片精选',
    tag: '知识',
    desc: 'BBC、国家地理等顶级纪录片，自然、历史、科技全覆盖，4K画质呈现地球之美。',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20landscape%20with%20warm%20sunset%20light%2C%20mountain%20silhouettes%2C%20golden%20hour%20photography%2C%20minimalist%20composition%2C%20serene%20atmosphere%2C%20warm%20earth%20tones%2C%20cinematic%20documentary%20style&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '经典老片修复',
    tag: '怀旧',
    desc: '影史经典影片4K数字修复版，重温黄金年代的不朽杰作，老电影焕发新生命。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20glowing%20light%2C%20old%20film%20reels%2C%20nostalgic%20atmosphere%2C%20sepia%20and%20warm%20golden%20tones%2C%20minimalist%20composition%2C%20elegant%20retro%20cinema%20aesthetic&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '动漫番剧库',
    tag: '二次元',
    desc: '热门日漫、国漫高清合集，从新番到经典番，4K重制版带来全新视觉体验。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20cityscape%20with%20warm%20sunset%20colors%2C%20soft%20illustration%20aesthetic%2C%20dreamy%20atmosphere%2C%20minimalist%20composition%2C%20warm%20pink%20and%20orange%20sky%20tones%2C%20elegant%20animation%20background&width=800&height=500&seq=card-06&orientation=landscape',
  },
];

export const contactInfo = {
  title: '商务合作 / 内容投稿',
  desc: '欢迎影视内容提供方、版权合作方与我们联系。555电影网致力于打造优质的4K超清影视平台，期待与行业伙伴携手共建高品质观影生态。',
  email: 'contact@555movie.com',
  wechat: 'movie555kf',
  qq: '1234567890',
};

export const updateItems = [
  {
    id: 1,
    date: '2025年7月30日',
    title: '《碟中谍8》4K版独家上线',
    desc: '汤姆·克鲁斯最新力作，IMAX拍摄原生4K画质，极限特技震撼呈现。',
    tag: '新片上线',
  },
  {
    id: 2,
    date: '2025年7月28日',
    title: '暑期档专题「仲夏夜之梦」上线',
    desc: '精选20部夏日主题影片，涵盖爱情、冒险、喜剧，陪你度过完美夏夜。',
    tag: '专题推荐',
  },
  {
    id: 3,
    date: '2025年7月25日',
    title: '播放器升级至v4.2版本',
    desc: '新增智能画质增强引擎，低码率片源也能通过AI算法提升至接近4K的观感。',
    tag: '功能更新',
  },
  {
    id: 4,
    date: '2025年7月22日',
    title: '「经典修复季」第三期上线',
    desc: '《教父》三部曲、《辛德勒的名单》等10部影史经典完成4K数字修复。',
    tag: '内容更新',
  },
  {
    id: 5,
    date: '2025年7月20日',
    title: 'CDN节点新增东南亚地区覆盖',
    desc: '新加坡、曼谷、雅加达三地节点上线，海外用户观影体验大幅提升。',
    tag: '平台公告',
  },
  {
    id: 6,
    date: '2025年7月18日',
    title: '《权力的游戏》全8季4K完整版',
    desc: 'HBO史诗巨制全系列4K HDR版本集结，维斯特洛大陆的传奇完整呈现。',
    tag: '重磅上线',
  },
  {
    id: 7,
    date: '2025年7月15日',
    title: '用户观影报告2025上半年发布',
    desc: '平台累计播放量突破50亿次，4K内容占比提升至78%，用户满意度达96.8%。',
    tag: '数据报告',
  },
];

export const aboutInfo = {
  title: '关于555电影网',
  subtitle: '让每个人都能享受4K超清影视的魅力',
  paragraphs: [
    '555电影网创立于2020年，是国内领先的4K超清影视在线平台。我们致力于为用户提供极致的观影体验，通过全球领先的视频压缩与传输技术，让高品质影视内容触手可及。',
    '平台汇聚超过20000部4K超清影片与剧集资源，涵盖院线大片、高分美剧、国产热剧、经典老片、纪录片、动漫番剧等全品类内容。我们与国内外多家知名内容提供商建立了深度合作关系，每日更新最新影视资源，确保用户始终能够找到想看的精彩内容。',
    '技术方面，555电影网采用自研的智能码率自适应引擎，配合全球CDN加速网络，无论用户身处何地，都能享受到稳定、流畅、不缓冲的4K观影体验。我们始终相信，好的技术应该服务于好的内容，让每一帧画面都能完美呈现。',
    '未来，555电影网将继续深耕4K超清影视领域，不断拓展内容边界，提升播放技术，优化用户体验。我们期待与广大影视爱好者一起，探索更广阔的光影世界。',
  ],
};

export const rankingItems = [
  {
    rank: 1,
    title: '《奥本海默》IMAX 4K版',
    hot: '9.8',
    tag: '传记/剧情',
    trend: 'up',
  },
  {
    rank: 2,
    title: '《沙丘2》导演加长版',
    hot: '9.7',
    tag: '科幻/冒险',
    trend: 'up',
  },
  {
    rank: 3,
    title: '《繁花》4K杜比全集',
    hot: '9.6',
    tag: '剧情/年代',
    trend: 'new',
  },
  {
    rank: 4,
    title: '《流浪地球2》导演剪辑版',
    hot: '9.5',
    tag: '科幻/灾难',
    trend: 'up',
  },
  {
    rank: 5,
    title: '《权力的游戏》4K全集',
    hot: '9.4',
    tag: '奇幻/史诗',
    trend: 'hot',
  },
];

export const appInfo = {
  title: '555电影网 · 移动端',
  subtitle: '随时随地，高清随行',
  desc: '555电影网移动客户端支持iOS与Android双平台，专为移动观影场景深度优化。智能流量节省模式让你在外也能放心观看4K内容，离线下载功能让你无网络也能畅享大片。',
  features: [
    '4K超清画质自适应',
    '智能省流模式',
    '离线下载随时看',
    '跨设备观影进度同步',
  ],
  image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20cinematic%20movie%20app%20interface%2C%20warm%20dark%20theme%20with%20golden%20accents%2C%20minimalist%20UI%20design%2C%20elegant%20device%20presentation%2C%20soft%20studio%20lighting%2C%20premium%20product%20photography%2C%20warm%20ambient%20background&width=600&height=900&seq=app-01&orientation=portrait',
};

export const carouselItems = [
  {
    id: 1,
    title: '暑期档特辑：仲夏光影盛宴',
    tag: '精选专题',
    desc: '炎热夏日，不如窝在空调房看一部好电影。我们为你精选了20部适合夏天观看的影片，从清凉的海洋纪录片到热血的冒险动作片，这个夏天，让光影陪你度过。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20summer%20evening%20scene%20with%20cinema%20screen%20on%20beach%2C%20soft%20golden%20sunset%20light%2C%20comfortable%20outdoor%20seating%2C%20ocean%20waves%20in%20background%2C%20minimalist%20composition%2C%20relaxing%20atmosphere%2C%20warm%20amber%20and%20coral%20tones&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '诺兰电影宇宙：时间与空间的艺术',
    tag: '导演专题',
    desc: '从《记忆碎片》到《奥本海默》，克里斯托弗·诺兰用独特的非线性叙事和震撼的实景拍摄重新定义了现代电影。本专题收录诺兰全部11部长片4K版本，带你完整领略这位电影大师的创作轨迹。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20geometric%20patterns%20and%20clock%20motifs%2C%20warm%20golden%20and%20dark%20amber%20tones%2C%20minimalist%20cinematic%20concept%20art%2C%20elegant%20time-themed%20visual%2C%20soft%20textured%20background&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国产科幻崛起之路',
    tag: '深度策划',
    desc: '从《流浪地球》开创中国科幻电影新纪元，到《宇宙探索编辑部》的另类表达，中国科幻正在走出自己的道路。本专题梳理国产科幻电影发展脉络，4K画质重温每一部里程碑作品。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20cityscape%20with%20warm%20sunrise%20light%2C%20sleek%20architecture%2C%20sci-fi%20aesthetic%20with%20Chinese%20design%20elements%2C%20minimalist%20composition%2C%20optimistic%20atmosphere%2C%20warm%20orange%20and%20gold%20tones%2C%20cinematic%20quality&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '纪录片里的真实世界',
    tag: '知识盛宴',
    desc: '优秀的纪录片让我们看到世界的真实与美好。从BBC自然纪录片的大美地球，到Netflix原创纪录片的深度调查，本专题汇集了评分最高的50部纪录片4K版本，打开你对世界的全新认知。',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20photography%20with%20warm%20natural%20light%2C%20dramatic%20mountain%20valley%2C%20golden%20hour%20sunlight%2C%20documentary%20style%20cinematography%2C%20breathtaking%20nature%20vista%2C%20warm%20earth%20and%20green%20tones%2C%20minimalist%20composition&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
];

export const commentItems = [
  {
    id: 1,
    name: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20profile%20avatar%20with%20warm%20beige%20background%2C%20simple%20abstract%20portrait%20style%2C%20soft%20lighting%2C%20elegant%20neutral%20aesthetic&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '3天前',
    content: '终于找到了能稳定看4K的地方！之前在其他平台要么画质虚标要么卡得要命，555的画质是真的顶，奥本海默的IMAX版细节炸裂！',
    rating: 5,
  },
  {
    id: 2,
    name: '周末电影人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20profile%20avatar%20with%20warm%20gray%20background%2C%20simple%20geometric%20abstract%20face%2C%20soft%20studio%20lighting%2C%20elegant%20modern%20aesthetic&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '5天前',
    content: '作为一个每周必看3部电影的人，这里的更新速度我是服气的。院线刚下映的片子这里就有4K版了，而且分类做得特别细，找片效率很高。',
    rating: 5,
  },
  {
    id: 3,
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20profile%20avatar%20with%20warm%20peach%20background%2C%20simple%20abstract%20portrait%2C%20soft%20natural%20lighting%2C%20elegant%20contemporary%20aesthetic&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '1周前',
    content: '权力的游戏4K全集真的太香了！以前看的720p简直是在浪费这部神剧。555的画质让我重新认识了维斯特洛大陆的每一寸土地。',
    rating: 5,
  },
  {
    id: 4,
    name: '纪录片爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20profile%20avatar%20with%20warm%20sand%20background%2C%20simple%20abstract%20geometric%20face%2C%20soft%20diffused%20lighting%2C%20elegant%20neutral%20aesthetic&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '2周前',
    content: 'BBC的《蓝色星球2》4K版美到窒息，每一帧都能当壁纸。记录片分类很全，从自然到人文到科技，已经推荐给身边所有朋友了。',
    rating: 4,
  },
  {
    id: 5,
    name: '老电影收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20profile%20avatar%20with%20warm%20cream%20background%2C%20simple%20abstract%20vintage%20style%20portrait%2C%20soft%20warm%20lighting%2C%20elegant%20retro%20aesthetic&width=80&height=80&seq=avatar-05&orientation=squarish',
    date: '3周前',
    content: '经典修复季这个栏目太赞了！《教父》4K修复版的画质简直像新拍的，感谢555让这些老电影重新发光。希望能多修复一些华语老片。',
    rating: 5,
  },
];

export const faqItems = [
  {
    id: 1,
    q: '555电影网的4K画质是真的4K吗？',
    a: '是的，我们提供的4K内容均为原生4K分辨率（3840×2160）片源，支持HDR10+与杜比视界。部分经典老片经过专业的4K数字修复流程，画质提升效果显著。我们不会对低分辨率片源进行简单拉伸后标注4K。',
  },
  {
    id: 2,
    q: '观看4K内容需要什么样的网络条件？',
    a: '推荐至少50Mbps的宽带网络以获得最佳4K观影体验。我们的智能码率自适应技术会根据您的实际网络状况自动调整画质，网络条件不佳时也能流畅播放，只是画质会自动适配。',
  },
  {
    id: 3,
    q: '支持哪些设备观看？',
    a: '555电影网支持PC浏览器（Chrome、Edge、Safari推荐）、iOS与Android移动客户端、智能电视与电视盒子。我们针对不同设备做了深度适配，确保各种屏幕尺寸下都能获得良好的观影体验。',
  },
  {
    id: 4,
    q: '内容更新频率是怎样的？',
    a: '我们每日更新最新影视资源，院线影片下线后通常在1-2周内上线4K版本。热门剧集与播出平台同步更新，经典修复内容每周四定期上新。关注首页「最新动态」模块可以第一时间了解更新信息。',
  },
  {
    id: 5,
    q: '如何联系版权合作或内容投稿？',
    a: '欢迎通过页面「联系我们」模块中的联系方式与我们沟通。我们期待与影视内容提供方、版权方建立合作关系，共同为用户提供更丰富的4K超清内容。商务合作邮箱：contact@555movie.com。',
  },
];

export const topicItems = [
  { id: 1, name: '4K电影推荐', count: '12.8万', color: 'primary' },
  { id: 2, name: '诺兰导演专题', count: '9.6万', color: 'accent' },
  { id: 3, name: '暑期观影指南', count: '8.3万', color: 'primary' },
  { id: 4, name: 'IMAX画质对比', count: '7.1万', color: 'secondary' },
  { id: 5, name: '国产科幻崛起', count: '6.5万', color: 'accent' },
  { id: 6, name: '经典电影修复', count: '5.9万', color: 'primary' },
  { id: 7, name: '高分美剧合集', count: '5.4万', color: 'secondary' },
  { id: 8, name: 'HDR观影体验', count: '4.8万', color: 'accent' },
  { id: 9, name: '纪录片精选', count: '4.2万', color: 'primary' },
  { id: 10, name: '杜比全景声', count: '3.7万', color: 'secondary' },
];

export const indexItems = [
  {
    id: 1,
    title: '动作冒险',
    icon: 'ri-sword-line',
    desc: '热血激战、极限追逐，肾上腺素飙升的观影体验',
    count: '2,360部',
  },
  {
    id: 2,
    title: '科幻奇幻',
    icon: 'ri-rocket-2-line',
    desc: '探索未知宇宙，开启想象力边界的奇幻之旅',
    count: '1,890部',
  },
  {
    id: 3,
    title: '剧情文艺',
    icon: 'ri-quill-pen-line',
    desc: '深刻叙事，细腻演绎，触动心灵的光影故事',
    count: '3,120部',
  },
  {
    id: 4,
    title: '喜剧搞笑',
    icon: 'ri-emotion-laugh-line',
    desc: '轻松一刻，欢乐不停，治愈你的不开心',
    count: '2,540部',
  },
  {
    id: 5,
    title: '悬疑惊悚',
    icon: 'ri-search-eye-line',
    desc: '烧脑反转，步步惊心，挑战你的推理极限',
    count: '1,670部',
  },
  {
    id: 6,
    title: '纪录片',
    icon: 'ri-earth-line',
    desc: '真实世界的精彩故事，拓宽认知边界的知识盛宴',
    count: '980部',
  },
  {
    id: 7,
    title: '动漫番剧',
    icon: 'ri-ghost-line',
    desc: '日漫国漫全收录，从新番到经典一站式追番',
    count: '1,450部',
  },
  {
    id: 8,
    title: '战争历史',
    icon: 'ri-flag-2-line',
    desc: '史诗级战争场面，历史的厚重与震撼尽在眼前',
    count: '820部',
  },
];

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '精彩推荐', href: '#media' },
  { label: '影视专题', href: '#cards' },
  { label: '热门榜单', href: '#ranking' },
  { label: '最新动态', href: '#updates' },
  { label: '关于我们', href: '#about' },
  { label: '影视索引', href: '#index' },
];